import GoldCoinSvg from './GoldCoinSvg';

export default GoldCoinSvg;

export { GoldCoinSvg };
